import type { CSSProperties } from 'react';

// Sizing and flex/grid placement belong to the outer field, not its button.
// Keep variants intact so responsive widths work just like a native select.
const layoutUtility = /^(?:(?:min-|max-)?(?:w|h|size)-|(?:flex|basis|grow|shrink|order|self|col|row|place-self)-|(?:m[trblxyse]?|inset(?:-[xy])?|top|right|bottom|left|start|end)-)/;
const layoutProperties = new Set(['width', 'minWidth', 'maxWidth', 'height', 'minHeight', 'maxHeight', 'inlineSize', 'minInlineSize', 'maxInlineSize', 'blockSize', 'minBlockSize', 'maxBlockSize', 'flex', 'flexBasis', 'flexGrow', 'flexShrink', 'order', 'alignSelf', 'justifySelf', 'gridArea', 'gridColumn', 'gridRow', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginInline', 'marginInlineStart', 'marginInlineEnd', 'marginBlock', 'marginBlockStart', 'marginBlockEnd']);

export function fieldLayout(className = '', style?: CSSProperties) {
  const layout: string[] = [], appearance: string[] = [];
  for (const token of className.split(/\s+/).filter(Boolean)) {
    // Colons inside arbitrary values/variants are not variant separators.
    let depth = 0, start = 0;
    for (let index = 0; index < token.length; index++) {
      if (token[index] === '[' || token[index] === '(') depth++;
      else if (token[index] === ']' || token[index] === ')') depth--;
      else if (token[index] === ':' && depth === 0) start = index + 1;
    }
    const utility = token.slice(start).replace(/^!?-?/, '').replace(/!$/, '');
    (layoutUtility.test(utility) || ['grow', 'shrink', 'hidden'].includes(utility) ? layout : appearance).push(token);
  }
  const outerStyle: CSSProperties = {}, innerStyle: CSSProperties = {};
  for (const [property, value] of Object.entries(style || {})) Object.assign(layoutProperties.has(property) ? outerStyle : innerStyle, { [property]: value });
  return { layoutClass: layout.join(' '), appearanceClass: appearance.join(' '), outerStyle, innerStyle };
}
